import styled from 'styled-components';

export const CourseVideoContainer = styled.div`
  position: relative;
`;
